import { mapMutations } from 'vuex';
import baseElement from '@/mixins/base-element/base-element-smart';
import {
    SET_VALIDATION_ERRORS,
} from '@/store/types/mutation-types';

export default {
    mixins: [baseElement],

    data() {
        return {
            atomicType: 'atom',
        };
    },

    created() {
        this.templateType = this.$options.name;
    },

    beforeMount() {
        this.setFieldValues();
    },

    methods: {
        ...mapMutations({
            setValidationErrors: SET_VALIDATION_ERRORS,
        }),

        // this method is overriden inside each atom
        setFieldValues() {
            // noop
        },

        validateElement() {
            if (!this.$attrs?.requiredProperties
                || this.$attrs.requiredProperties.length < 1) {
                return;
            }

            this.validationErrors = [];
            for (let i = 0; i < this.$attrs.requiredProperties.length; i++) {
                const prop = this.$attrs.requiredProperties[i];

                if (!this[prop.propertyName] && !this[`${ prop.propertyName }Default`]) {
                    this.addValidationError(this, `${ prop.displayName } is required`);
                }
            }
            this.setValidationErrors({ element: this, messages: this.validationErrors });
        },

        isRequiredPropertyValid(propertyName) {
            if (!this.$attrs?.requiredProperties
                || this.$attrs.requiredProperties.length < 1) {
                return true;
            }

            let valid = true;
            for (let i = 0; i < this.$attrs.requiredProperties.length; i++) {
                const prop = this.$attrs.requiredProperties[i];
                if (!this[prop.propertyName]
                    && !this[`${ prop.propertyName }Default`]
                    && propertyName === prop.optionName) {
                    valid = false;
                    break;
                }
            }

            return valid;
        },
    },
};
